// Added by Sejune Oh on 2020-02-20
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import React, { FC, RefObject } from 'react'
import { withStyles, Theme, createStyles, WithStyles } from '@material-ui/core'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import Intl from '@/helper/Intl'
import { ReactEmptyEvent, ReactClickEvent } from '@/helper/define'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import MgmtComponentFormStyle from '@/styles/management/MgmtComponentFormStyle'
import { CustomInfoTable, CustomInfoDialog } from '../index'
import { DisplableUserCustomInfoProp } from '../CustomInfoTable'
import { UserCustomInfoProp } from '@/stores/mgmt/user/UserStore'
import { Button, Typography } from '@/components/_primes'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Interface
interface CustomInfoFCProps extends WithStyles<typeof styles> {
    dataStorageId?: string
    customInfoList: Array<DisplableUserCustomInfoProp>
    onAddCustomInfoBtnClick: ReactEmptyEvent
    customInfoDialogRef: RefObject<any>
    customInfoTableRef: RefObject<any>
    customInfoElement?: UserCustomInfoProp
    onDialogConfirm: (arg: { customInfoElement: UserCustomInfoProp | null; err: Error | null }) => Promise<{}>
    onRowClick: ReactClickEvent
    menuItems: string[]
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
const CustomInfo: FC<CustomInfoFCProps> = ({ classes, ...props }) => {
    const hasStudyTag = props.customInfoList!.length > 0
    const descAddStudyTag = Intl.getIntlText({ id: 'htmljs_react.mgmt.custominfo.desc_add' })
    const btnAdd = Intl.getIntlText({ id: 'htmljs_react.mgmt.custominfo.btn_add' })

    return (
        <div className={classes.CtrWrapper}>
            <div className={classes.ControlBtnWrapper}>
                <Typography variant="body1" className={classes.ControlTextWrapper}>
                    {descAddStudyTag}
                </Typography>
                <Button onClick={props.onAddCustomInfoBtnClick} btnText={btnAdd} />
            </div>
            {hasStudyTag && (
                <div className={classes.StorageTagTableWrapper}>
                    <CustomInfoTable
                        ref={props.customInfoTableRef}
                        elements={props.customInfoList!}
                        onRowClick={props.onRowClick}
                    />
                </div>
            )}
            <CustomInfoDialog
                ref={props.customInfoDialogRef}
                onDialogConfirm={props.onDialogConfirm}
                customInfoElement={props.customInfoElement}
                menuItems={props.menuItems}
            />
        </div>
    )
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Styles
const styles = (theme: Theme) =>
    createStyles({
        ...MgmtComponentFormStyle(theme),
        StorageTagTableWrapper: {},
    })

export default withStyles(styles, { withTheme: true })(CustomInfo)
